export default __webpack_public_path__ + "static/media/gclogo.8cda4f3a.png";